import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { WeightUnitConverter } from "@/Common/Utilities/Units/WeightUnitConverter";
import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";

class Pregnancy extends JsonSerializable {
    private id: number;

    public Number: number;
    public Date: Date;
    public DatePrecision: LifeStageDatePrecisionEnum;
    public Place: string;
    public DurationOfPregnancyInWeeks: GestationalAge;
    public DurationOfLabourInHours: string;
    public MethodOfDelivery: string;
    public TypeOfAnesthesia: string;
    public Gender: string;
    public MassInKg: string; // Obsolete: Use Mass instead
    public Mass: number;
    public ParticularityMother: string;
    public ParticularityChild: string;

    constructor(fields?: Partial<Pregnancy>) {
        super({ excludedFields: ["id"] });
        Object.assign(this, fields);
        this.id = sessionStore.newId();
        this.DurationOfPregnancyInWeeks = new GestationalAge(fields?.DurationOfPregnancyInWeeks);
    }

    public get Id(): number {
        return this.id;
    }

    public getMassString(): string {
        return this.Mass
            ? this.Mass.toString()
            : this.MassInKg; // do this for backward compatibility
    }

    public convertMass(fromUnit: WeightUnit, toUnit: WeightUnit): void {
        let mass = Number(this.getMassString());
        if (isNaN(mass))
            return;

        this.Mass = WeightUnitConverter.convert(fromUnit, toUnit, mass, 2);
    }

    public hasValue(): boolean {
        return !!this.Date
            || !!this.Place
            || this.DurationOfPregnancyInWeeks?.hasValue()
            || !!this.DurationOfLabourInHours
            || !!this.MethodOfDelivery
            || !!this.TypeOfAnesthesia
            || !!this.Gender
            || !!this.MassInKg
            || !!this.Mass
            || !!this.ParticularityMother
            || !!this.ParticularityChild;
    }
}

export { Pregnancy };
